// Development-mode only function that requires Proxies. Wraps a passed object
// and checks that neither it nor any of its nested objects are mutated.

let wrapWithImmCheck;
let checkActive = false;

if (!global.Proxy || !global.WeakMap) {
	wrapWithImmCheck = x => x;
} else {
	checkActive = true;
	const canBeWrapped = x => x && typeof x === "object";
	const wrapperCache = new WeakMap();
	wrapWithImmCheck = function(x, onError) {
		if (!canBeWrapped(x)) {
			return x;
		}
		if (wrapperCache.has(x)) {
			return wrapperCache.get(x);
		}
		const proxy = new Proxy(x, {
			get: (target, name) => {
				return wrapWithImmCheck(target[name], onError);
			},
			set: (target, name, value) => {
				onError(target, name, target[name], value);
				target[name] = value;
				return true;
			},
			deleteProperty: (target, name) => {
				onError(target, name, target[name]);
				delete target[name];
				return true;
			},
		});
		wrapperCache.set(x, proxy);
		return proxy;
	};
}

module.exports = {
	checkActive,
	wrapWithImmCheck,
};
